const social = [
    {
        id: 1,
        name: 'TikTok',
        link: 'https://www.tiktok.com/@thepackmack?_t=ZT-8sSisDkoBeV&_r=1',
        icon: 'https://i.imgur.com/68axNi6.png'
    },
    {
        id: 2,
        name: 'YouTube',
        link: 'https://youtube.com/@elitemagicalbeats?si=dtzUyFXAWx_NBT_l',
        icon: 'https://i.imgur.com/Z5s5hrn.png'
    },
    {
        id: 3,
        name: 'Archidekt',
        link: 'https://archidekt.com/search/decks?owner=thepackmack&ownerexact=true',
        icon: 'https://i.imgur.com/CPesF8Q.png',
    },
    {
        id: 3,
        name: 'BlueSky',
        link: 'https://bsky.app/profile/thepackmack.bsky.social',
        icon: 'https://i.imgur.com/IIXCTFI.png'
    },
    {
        id: 4,
        name: 'Spotify',
        link: 'https://open.spotify.com/user/daigosensei?si=7KlcEuKnTzeQgCYuyB2BMw',
        icon: 'https://i.imgur.com/lstdrLq.png'
    },
    {
        id: 5,
        name: 'Soundcloud',
        link:  'https://on.soundcloud.com/8mwSj3coKv4DmRmm6',
        icon: 'https://i.imgur.com/b3cytfM.png'
    }
]

export default social